import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ReservationCategories } from "./ReservationCategories";
import { ReservationItems } from "./ReservationItems";
import { ReservationCalendar } from "./ReservationCalendar";
import { UserReservations } from "./UserReservations";
import { Layers } from "lucide-react";

type View = 'categories' | 'items' | 'calendar' | 'my-reservations';

interface ReservationsSectionProps {}

export const ReservationsSection = ({}: ReservationsSectionProps) => {
  const [currentView, setCurrentView] = useState<View>('categories');
  const [selectedCategory, setSelectedCategory] = useState<{ id: string; name: string } | null>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const handleSelectCategory = (categoryId: string, categoryName: string) => {
    setSelectedCategory({ id: categoryId, name: categoryName });
    setCurrentView('items');
  };

  const handleSelectItem = (item: any) => {
    setSelectedItem(item);
    setCurrentView('calendar');
  };

  const handleBackToCategories = () => {
    setSelectedCategory(null);
    setSelectedItem(null);
    setCurrentView('categories');
  };

  const handleBackToItems = () => {
    setSelectedItem(null);
    setCurrentView('items');
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'categories':
        return (
          <div className="space-y-4">
            <h2 className="pt-1 text-2xl font-semibold flex items-center gap-2">
              <Layers className="h-6 w-6" />
              Categorías de reservas
            </h2>
            <ReservationCategories onSelectCategory={handleSelectCategory} />
          </div>
        );

      case 'items':
        return selectedCategory ? (
          <ReservationItems 
            categoryId={selectedCategory.id}
            categoryName={selectedCategory.name}
            onBack={handleBackToCategories}
            onSelectItem={handleSelectItem}
          />
        ) : null;

      case 'calendar':
        return selectedItem ? (
          <ReservationCalendar 
            item={selectedItem}
            onBack={handleBackToItems}
          />
        ) : null;

      case 'my-reservations':
        return <UserReservations onBack={handleBackToCategories} />;

      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      {renderCurrentView()}
    </div>
  );
};